(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhpl-collection-popup"]) return;
  try {
    
(function() {
  const ANCHOR = 'main-collection-anchor';

  function scrollToMainCollection() {
    const target = document.querySelector('[id$="__main-collection"]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }
    return false;
  }

function handleLinkClick(e) {
  const link = e.target.closest('.mhpl-popup-collection-all a');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href || !href.includes('/collections/')) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const hashIndex = href.indexOf('#');
  const linkPath = hashIndex > -1 ? href.slice(0, hashIndex) : href;
  const currentPath = window.location.pathname;
  const isSamePage = !linkPath || linkPath === currentPath;

  if (isSamePage) {
    scrollToMainCollection();
  } else {
    sessionStorage.setItem(ANCHOR, '1');
    window.location.replace(linkPath);
  }
}


  document.addEventListener('click', handleLinkClick, { capture: true });

  // Восстановление скролла после перехода
  if (sessionStorage.getItem(ANCHOR)) {
    sessionStorage.removeItem(ANCHOR);
    function tryScroll(attempts) {
      if (scrollToMainCollection()) return;
      if (attempts > 0) setTimeout(() => tryScroll(attempts - 1), 200);
    }
    setTimeout(() => tryScroll(15), 400);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
